import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './device_index.routes';
import SaConfigService from '../../../../components/api/sa_config/sa_config.service';
import CompanyService from '../../../../components/api/company/company.service';
import ControllerConfigService from '../../../../components/api/controller_config/controller_config.service';
import SaConfigSearchService from '../../../../components/api/sa_config_search/sa_config_search.service';

export class OemDeviceIndexController {
  /*@ngInject*/
  constructor($state, SaConfigService, $stateParams, CompanyService, ControllerConfigService, SaConfigSearchService) {
    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$stateParams = $stateParams;

    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.CompanyService = CompanyService;
    this.ControllerConfigService = ControllerConfigService;
    this.SaConfigSearchService = SaConfigSearchService;

    this.pagination = {};

    this.searched = (this.company_id === 'search');
  }

  $onInit() {
    this.changePage(1);
  }

  changePage(page) {
    if (this.searched) {
      const target = this.$stateParams.target;
      const value = this.$stateParams.value;
      this.loadDeviceBySearch(target, value, page);
    } else {
      this.validateCompany();
      this.loadDeviceByCompany(page);
    }
  }

  loadDeviceByCompany(page) {
    this.SaConfigService.oem_api.pageIndex({company_id: this.company_id, page: page}).$promise.then(response => {
      this.saList = response.sa_configs;
      this.pagination = response.pagination;

      return this.ControllerConfigService.oem_api.index({company_id: this.company_id}).$promise;
    }).then(response => {
      let controllerDeviceList = response;

      // 検針用端末に紐付く制御用端末を controlTargets に格納する
      this.saList.forEach(device => {
        device.controlTargets = controllerDeviceList.filter(controllerDevice => {
          return controllerDevice.reading_device_id === device.id;
        });
      });
    });
  }

  loadDeviceBySearch(target, value, page) {
    this.company = {name: '検索結果'};
    this.SaConfigSearchService.oem_api.pageIndex({target: target, value: value, page: page}, res => {
      this.saList = res.sa_configs;
      this.pagination = res.pagination;
    });
  }

  validateCompany() {
    this.CompanyService.show({id: this.company_id}, response => {
      this.company = response;
    }, err => {
      if (err.status === 404 || err.status === 403) {
        this.$state.go('oem_main.oem_home');
      }
    });
  }
}

export default angular.module('leptonApp.oemDeviceIndex', [uiRouter, SaConfigService, CompanyService, ControllerConfigService, SaConfigSearchService])
  .config(routing)
  .component('oemDeviceIndex', {
    template: require('./device_index.html'),
    controller: OemDeviceIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/index/device_index.component.js